<template>
  <Modal
    class="cc-modal"
    width="600"
    footer-hide
    v-model="visibility"
    title="企业认证"
  >
    <div class="content" style="position: relative">
      <loading :loading="loading" style="z-index: 11"></loading>
      <div class="section">
        <div class="col">
          <div class="name">企业名称：</div>
          <Input
            class="height45"
            v-model="form.cpn"
            placeholder="请输入企业名称"
            style="width: 200px"
            clearable
          />
        </div>
        <div class="col">
          <div class="name">证件类型：</div>
          <Select
            class="height45"
            v-model="form.type"
            style="width: 200px"
          >
            <Option
              v-for="item in typeList"
              :key="item.value"
              :value="item.value"
              >{{ item.label }}</Option
            >
          </Select>
        </div>
        <div class="col">
          <div class="name">证件号码：</div>
          <Input
            class="height45"
            v-model="form.ca"
            placeholder="请输入证件号码"
            style="width: 200px"
            clearable
          />
        </div>
        <div class="col">
          <div class="name">证件正面照：</div>
          <Upload
            v-if="!form.imgU"
            style="width: 200px"
            type="drag"
            :before-upload="handleBeforeUpload"
            :show-upload-list="false"
            action="/"
          >
            <div class="upload-section">
              <img class="icon" src="@/assets/image/upload-icon.png" />
            </div>
          </Upload>
          <div
            class="icon2"
            :style="{ backgroundImage: 'url(' + form.imgU + ')' }"
            v-else
          >
            <div class="close" @click="delImage">
              <Icon size="28" type="ios-close-circle-outline" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="foot">
      <Button
        :loading="loading"
        @click="onConfirm"
        type="primary"
        style="margin-right: 20px"
        >确定</Button
      >
      <Button @click="onCancel">取消</Button>
    </div>
  </Modal>
</template>
<script>
import { enterpriseIdentitySave, enterpriseIdentityUpload } from "api/customer.js";
import { mapMutations } from "vuex";
import loading from "components/loading.vue";
export default {
  name: "updateCertifiedModal",
  components: {
    loading,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      typeList: [
        {
          value: 1,
          label: "企业组织机构代码证",
        },
        {
          value: 2,
          label: "营业执照",
        },
        {
          value: 4,
          label: "统一社会信用代码证",
        },
        {
          value: 3,
          label: "北京市外国驻华使馆人员子女学校办学许可证",
        },
        {
          value: 5,
          label: "事业单位法人证书",
        },
        {
          value: 6,
          label: "社会团体法人登记证书",
        },
        {
          value: 7,
          label: "民办非企业单位登记证书",
        },
        {
          value: 8,
          label: "律师事务所执业许可证",
        },
        {
          value: 9,
          label: "司法鉴定许可证",
        },
        {
          value: 10,
          label: "宗教活动场所登记证",
        },
        {
          value: 11,
          label: "基金会法人登记证书",
        },
        {
          value: 12,
          label: "部队代号",
        },
        {
          value: 13,
          label: "军队单位对外有偿服务许可证",
        },
        {
          value: 14,
          label: "外国企业常驻代表机构登记证",
        },
        {
          value: 15,
          label: "外国在华文化中心登记证",
        },
        {
          value: 16,
          label: "外国政府旅游部门常驻代表机构批准登记证",
        },
        {
          value: 17,
          label: "境外机构证件",
        },
        {
          value: 18,
          label: "社会服务机构登记证书",
        },
        {
          value: 19,
          label: "民办学校办学许可证",
        },
        {
          value: 20,
          label: "医疗机构执业许可证",
        },
        {
          value: 31,
          label: "仲裁委员会登记证",
        },
        {
          value: 32,
          label: "农村集体经济组织登记证",
        },
        {
          value: 33,
          label: "中华人民共和国社会信用代码证书",
        },
        {
          value: 34,
          label: "港澳台地区旅游部门常驻代表机构批准登记证",
        },
        {
          value: 35,
          label: "外国驻华新闻机构证",
        },
        {
          value: 36,
          label: "境外非政府组织代表机构登记证书",
        },
        {
          value: 37,
          label: "港澳新闻机构常驻内地记者站登记证",
        },
        {
          value: 38,
          label: "其他境外机构登记证",
        }
      ],
      form: {
        cpn: "",
        type: 0, // 0：身份证 1：护照
        ca: "",
        file: "",
        imgN: "",
        imgU: "",
        legalPerson: "",
      },
      loading: false,
      uploading: false,
    };
  },
  computed: {
    visibility: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit("update:show", val);
      },
    },
  },
  methods: {
    ...mapMutations(["MUT_USER_INFO_COMPANY"]),
    onCancel() {
      this.form = this.$options.data().form;
      this.visibility = false;
    },
    async onConfirm() {
      if (!this.form.cpn) {
        this.$Message.warning("请输入企业名称！");
        return;
      }
      if (!this.form.ca) {
        this.$Message.warning("请输入正确的证件号码！");
        return;
      }
      if (!this.form.imgN) {
        this.$Message.warning("请上传证件正面图片！");
        return;
      }
      this.loading = true;
      const data = {
        cpn: this.form.cpn,
        type: this.form.type, // 0：身份证 1：护照
        ca: this.form.ca,
        imgN: this.form.imgN,
        imgU: this.form.imgU,
      };
      try {
        const res = await enterpriseIdentitySave(data);
        this.loading = false;
        if (res.code === 200 && res.result) {
          this.MUT_USER_INFO_COMPANY(this.form.cpn);
          this.$emit("submit-success", (res) => {
            if (res) {
              this.onCancel();
              this.$Message.success("添加成功！");
            }
          });
        }
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
    // 选择图片后处理
    handleBeforeUpload(file) {
      if (
        file.type !== "image/jpeg" &&
        file.type !== "image/png" &&
        file.type !== "image/jpg"
      ) {
        this.$Message.warning("图片要求上传jpg或者png格式或者jpeg格式");
        return false;
      }
      this.form.file = file;
      this.form.imgU = window.URL.createObjectURL(file);
      this.uploadCompanyPhoto();
      return false;
    },
    // 删除图片
    delImage() {
      this.form.imgU = "";
      this.form.file = "";
    },
    // 上传图片
    async uploadCompanyPhoto() {
      try {
        this.loading = true;
        const data = new FormData();
        data.append("file", this.form.file);
        const res = await enterpriseIdentityUpload(data);
        if (res.code === 200) {
          if (res.data.cpn != null && res.data.cpn !== "")
            this.form.cpn = res.data.cpn;
          if (
            res.data.ca != null &&
            res.data.ca !== ""
          )
            this.form.ca = res.data.ca;
          if (res.data.person != null && res.data.person !== "")
            this.form.legalPerson = res.data.person;
          this.form.imgU = res.data.u;
          this.form.imgN = res.data.p;
        } else {
          this.deletePic();
        }
        this.loading = false;
      } catch (error) {
        this.loading = false;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.cc-modal {
  .content {
    height: auto;
    min-height: 100px;
    max-height: 500px;
    overflow: auto;
  }
  .foot {
    border-top: 1px solid #dcdee2;
    padding-top: 16px;
    display: flex;
    justify-content: flex-end;
  }
}
.col {
  margin-left: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-bottom: 20px;
  .name {
    color: #333333;
    font-size: 16px;
    margin-bottom: 10px;
  }
  .label {
    color: #999999;
  }
}
.upload-section {
  width: 200px;
  height: 122px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  .icon {
    width: 45px;
    height: 35px;
  }
}
.icon2 {
  border: 1px dashed #dcdee2;
  position: relative;
  width: 200px;
  height: 122px;
  background-size: cover;
  background-position: center;
  .close {
    position: absolute;
    right: 5px;
    top: 5px;
    cursor: pointer;
  }
}
</style>

<style lang="less" scoped>
/deep/.height45 {
  .ivu-input {
    height: 45px;
    line-height: 45px;
  }
  .ivu-input-icon {
    line-height: 45px;
  }
  .ivu-input-with-prefix {
    padding-left: 60px;
  }
  .ivu-input-prefix {
    width: 60px;
    padding: 0 10px;
  }
  .ivu-select-selection {
    height: 45px;
  }
  .ivu-select-input {
    height: 45px;
  }
  .ivu-select-selected-value {
    height: 45px;
    line-height: 45px;
  }
  .ivu-select-placeholder {
    height: 45px;
    line-height: 45px;
  }
  .ivu-input-prefix i,
  .ivu-input-suffix i {
    line-height: 45px;
  }
}
</style>
